import { useMemo } from 'react';
import { DisplayField } from '@mews-commander/guest-profile';
import { FieldsGridProps } from '../components';

type PreSelectedInitialValuesParams = Pick<FieldsGridProps, 'preSelectedFields'>;

export const usePreSelectedInitialProfileIds = ({ preSelectedFields }: PreSelectedInitialValuesParams) => {
    const defaultProfileIds = useMemo(
        () =>
            preSelectedFields.reduce(
                (acc, { field, profileId }) => {
                    if (profileId) {
                        acc[field] = {
                            profileId,
                        };
                    }
                    return acc;
                },
                {} as Record<DisplayField, { profileId: string }>
            ),
        [preSelectedFields]
    );

    return defaultProfileIds;
};
